export function clearWrittenData() {
  useCompanyStore().clear();
  useOrganizationStore().clear();
  useProfileStore().clear();
  useScanStore().clear();
  useScan().clear();
  useUserStore().clear();
  localStorage.clear();
}
